<script setup lang="ts">
import GradientButton from "@/components/buttons/GradientButton.vue";
import { defineProps } from "vue";

defineProps<{
  btnClasses: string | null;
  iconClasses?: string | null;
  iconSrc: string;
}>();
</script>

<template>
  <GradientButton
    class="rounded-xl shrink-0"
    :class="btnClasses"
    bg-color="bg-brown-gradient"
    hover-bg-color="bg-orange-gradient"
    text=""
    @click="$emit('click')"
  >
    <template #icon>
      <img :src="iconSrc" alt="Print" class="z-10" :class="iconClasses" />
    </template>
  </GradientButton>
</template>
